import React, { useState } from "react";
import "../styles/faq.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How does the service work?",
      answer:
        "Our service allows you to upload audio files and transcribes them into text with high accuracy using advanced AI technology. Simply upload your file, wait for processing, and get your transcription with translation options.",
    },
    {
      question: "How is it secure?",
      answer:
        "We use advanced encryption and security measures to ensure your data remains private and secure. All uploaded files are processed securely and automatically deleted after processing to protect your privacy.",
    },
    {
      question: "Is Transcripto free?",
      answer:
        "You bet it's free - and it always will be! We believe in making transcription and translation services accessible to everyone without any hidden costs or premium barriers.",
    },
    {
      question: "Is there a maximum recording length?",
      answer:
        "Currently, we support audio files up to 25MB in size, which typically covers recordings of several hours. We're continuously working to expand these limits based on user needs.",
    },
    {
      question: "What languages does your transcription service work for?",
      answer:
        "For now, our transcription service primarily works with English audio. However, we're actively developing support for multiple languages including Spanish, French, German, and more coming soon!",
    },
    {
      question: "How many translation languages do you support?",
      answer:
        "Our service provides translation into 10+ languages including Spanish, French, German, Italian, Portuguese, Russian, Chinese, Japanese, Korean, and Arabic with more languages being added regularly.",
    },
    {
      question: "Can I support this project?",
      answer:
        "Yes! You can support us through donations, sharing our service with others, providing feedback, or contributing to our open-source development. Every bit of support helps us improve and expand our services.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <hr className="separator" />
      <div className="faq-container">
        <h2 className="faq-title">
          FA<span>Q</span>
        </h2>
        <p className="faq-subtitle">For those curious of mind.</p>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">{faq.question}</div>
              <div className="faq-answer">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQ;